

export default (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    if (isMouseDownHandled) {
      console.error('Cannot handle mouse down as it is already handled');
      return;
    }
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/drag-handle/util/create-event-marshal.js
// module id = 231
// module chunks = 0